import BaseTable from 'components/Tables/BaseTable';
import { sortBy } from 'lodash';
import filterMergeProductDescriptors
  from "pages/ScenarioExposure/Product/ScenariosManagement/filterMergeProductDescriptors";
import ProductListDetailPanel from "pages/ScenarioExposure/Product/ScenariosManagement/ProducListDetailPanel";
import ProductListByPCDetailPanel from "pages/ScenarioExposure/Product/ScenariosManagement/ProductListByPCDetailPanel";
import React from 'react';
import { connect } from 'react-redux';
import { getImmutableStoreData, lookUpIdValueSelector } from 'selectors/generic';
import theme from 'source/theme';
import { ERC, PC, PROC } from "utils/constants/descriptorTypes";
import tableIcons from 'utils/icons/materialTableIcons';
import columns from 'utils/tables/columns/scenarioConditions';
import { TABLE_HEIGHT_SPLIT_4VIEW } from 'utils/ui/constants';
import { currentUser } from 'selectors/currentUser';

const TABLE_HEIGHT = TABLE_HEIGHT_SPLIT_4VIEW(64);

const Component = props => {
  const {
    conditionsById, descriptorId, descriptorsById, descriptorsData, descriptorFilter, productsById,
    productScenarioDescriptors, scenariosById, scenarioDescriptors, scenarioDescriptorConditionsData, units, user
  } = props;

  const selectedSD = scenarioDescriptors.filter(sd =>
    (descriptorId && sd.descriptor_id === descriptorId)
  );

  let filteredSDC = {};
  const sdcConditionRepetitions = [];

  selectedSD.forEach(sSD => {
    const productId = scenariosById[sSD.scenario_id].product_id;
    const productInfo = {
      product_id: productId,
      code: productsById[productId].code,
      name: productsById[productId].name
    };

    const sdcs = scenarioDescriptorConditionsData.filter(sdc => sdc.scenario_descriptor_id === sSD.id);
    sdcs.forEach(sdc => {
      // TODO Probably later Ana will want some crazy distintion, so I will leave this code here to remember
      // const uniqueId = `${sdc.condition_id}-${sdc.value}-${sdc.unidade}`
      const uniqueId = `${sdc.condition_id}`;

      if (sdcConditionRepetitions.includes(uniqueId)) {
        filteredSDC[uniqueId].productsInfo.push(productInfo);
      } else {
        filteredSDC[uniqueId] = { ...sdc, productsInfo: [productInfo] };
        sdcConditionRepetitions.push(uniqueId);
      }
    });
  });

  const rows = Object.values(filteredSDC).map(element => {
    const subtype = conditionsById[element.condition_id].subtype;
    const name = conditionsById[element.condition_id].name;
    return { ...element, subtype, name };
  });

  const rowsSorted = sortBy(rows, ['subtype', 'id']);

  const delayedPCmergedProductDescriptors = () => filterMergeProductDescriptors(
    PC, productsById, descriptorsById, descriptorsData, productScenarioDescriptors, scenariosById
  );

  return (
    <React.Fragment>
      <BaseTable
        title={'CONDIÇÕES DO PRODUTO'}
        columns={columns(user, units)}
        data={descriptorId ? rowsSorted : []}
        order={false}
        paging={false}
        options={{
          // toolbar: false,
          // search: false,
          maxBodyHeight: TABLE_HEIGHT,
          minBodyHeight: TABLE_HEIGHT,
          rowStyle: () => ({ backgroundColor: theme.palette.background.veryLight })
        }}
        detailPanel={[
          () => ({
            icon: tableIcons.Products,
            tooltip: 'Produtos',
            render: descriptorFilter === PROC || descriptorFilter === ERC ?
              ({ rowData }) => <ProductListByPCDetailPanel
                row={rowData}
                pcListOfProduct={delayedPCmergedProductDescriptors()}
              /> :
              ({ rowData }) => <ProductListDetailPanel row={rowData}/>

          })
        ]}
      />
    </React.Fragment>
  );
};

const makemapStateToProps = () => {
  const units = lookUpIdValueSelector('units', ['name']);
  const immutableDescriptorsData = getImmutableStoreData('descriptors');
  const mapStateToProps = (state, props) => ({
    conditionsById: state.conditions.models,
    descriptorsData: immutableDescriptorsData(state),
    descriptorsById: state.descriptors.models,
    productsById: state.products.models,
    scenariosById: state.scenarios.models,
    scenarioDescriptorConditionsData: state.scenarioDescriptorConditions.data,
    units: units(state),
    user: currentUser(state)
  });
  return mapStateToProps;
};

export default connect(makemapStateToProps)(Component);
